import { render, staticRenderFns } from "./DavlatMukofot.vue?vue&type=template&id=767fd226&scoped=true&"
import script from "./DavlatMukofot.vue?vue&type=script&lang=js&"
export * from "./DavlatMukofot.vue?vue&type=script&lang=js&"
import style0 from "./DavlatMukofot.vue?vue&type=style&index=0&id=767fd226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fd226",
  null
  
)

export default component.exports